export default "__VITE_ASSET__CRIOeBrH__"